import axiosClient from "../api/axiosClient";

/**
 * Disputes service.
 * Ported 1:1 from the React Native app's dispute-list, add-dispute, and
 * paid-events screens (src/Screens/*) and the API functions they call in
 * src/services/api/index.js + src/services/constants/index.js. Backend
 * terminology is "Claim" (Events/EventClaim/*); mobile's UI-facing name is
 * "Dispute", kept here too. No new backend endpoints — all of the below are
 * already live.
 */

// --- Read ---
/** @param {{pageNumber, pageSize}} params */
export const getMyDisputes = (params) => axiosClient.get("/Events/EventClaim/My", { params });

/** Eligible paid events/galleries a new claim can be filed against. */
export const getEligibleClaimEvents = (params) =>
  axiosClient.get("/Events/EventClaim/Eligible", { params });

export const getClaimTypes = () => axiosClient.get("/Events/ClaimTypes");

// --- Write ---
/** @param {{eventId, eventGalleryId, albumId, ClaimTypeId, description}} payload */
export const addClaim = (payload) => axiosClient.post("/Events/EventClaim", JSON.stringify(payload));

/** @param {string|number} claimId @param {string[]} fileUrls */
export const addClaimProof = (claimId, fileUrls) =>
  axiosClient.post(`/Events/EventClaim/${claimId}/Proof`, JSON.stringify({ fileUrls }));

/** @param {{claimId, response}} payload */
export const respondToClaim = (payload) =>
  axiosClient.post("/Events/EventClaim/Respond", JSON.stringify(payload));

// --- Proof upload ---
/**
 * Up to 3 proof files in one Image/Bulk call, matching mobile's
 * add-dispute/document-picker (maxFiles: 3).
 * @param {File[]} files
 * @returns {Promise<string[]>} uploaded URLs
 */
export const uploadDisputeProof = async (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  formData.append("folderName", "DisputeProof");
  const res = await axiosClient.post("/Image/Bulk", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
  });
  const body = res.data;
  const ok = body?.status === "Success" || body?.Status === "Success";
  const result = body?.result ?? body?.Result ?? [];
  if (!ok || !Array.isArray(result)) return [];
  return result.map((r) => r?.originalUrl ?? r?.OriginalUrl ?? r?.url ?? r?.Url).filter(Boolean);
};
